import type {
  LessonModelsNeededForFirstEdit,
  ModelsNeededForFirstEdit,
} from "cc-frontend/services/lesson-editor"

/**
 * The ids a lesson edit action must carry. Every edit surface knows its planbook — and, for
 * lessons, its course and day — so actions carry them explicitly instead of trusting a store
 * lookup at narrative time.
 */
export interface LessonEditIds {
  planbookId: string
  courseId: string | null
  dateString: string | null
}

function isLessonModels(
  models: ModelsNeededForFirstEdit
): models is LessonModelsNeededForFirstEdit {
  return models.cardStack.attributes.usedAs === "lesson"
}

export function lessonEditIds(models: ModelsNeededForFirstEdit): LessonEditIds {
  if (isLessonModels(models)) {
    return {
      planbookId: models.planbook.id,
      courseId: models.course.id,
      dateString: models.dateString,
    }
  }
  return {
    planbookId: models.cardStack.relationships.planbook.data.id,
    courseId: models.cardStack.relationships.course?.data?.id ?? null,
    dateString: null,
  }
}
